<template>
<div class="info">
	<Form :label-width="120" class="mt15">
	    <FormItem label="订单号：" class="w600">
	        {{info.orderNo}}
	    </FormItem>
	    <FormItem label="订单状态：" class="w600">
	        {{info.orderStatusDesc}}
	    </FormItem>
	    <FormItem label="订单创建时间：" class="w600">
	        {{info.createTime}}
	    </FormItem>
		<div v-if="info.orderStatus=='PAID'||info.orderStatus=='PAID_NEED_CONFIRM'">
			<FormItem label="支付方式：" class="w600">
				{{info.paymentSourceDesc}}
			</FormItem>
			<FormItem label="支付时间：" class="w600">
				{{info.paymentTime}}
			</FormItem>
			<FormItem label="订单总额：" class="w600" v-if="info.pointAmount">
				<span class="price">{{info.totalAmount}} 元</span>
			</FormItem>
			<FormItem label="抵扣金额：" class="w600" v-if="info.pointAmount">
				<span class="price">{{info.pointAmount}} 元</span>
			</FormItem>
			<FormItem label="支付金额：" class="w600">
				<span class="price">{{info.buyerPayAmount}} 元</span>
			</FormItem>
		</div>
		<FormItem label="保障凭证号：" class="w600" v-if="info.guaranteeNo">
			{{info.guaranteeNo}}
		</FormItem>
		<FormItem label="保障起期：" class="w600">
			{{info.effectiveDateStart||''}}
		</FormItem>
		<FormItem label="保障止期：" class="w600">
			{{info.effectiveDateEnd||''}}
		</FormItem>
		<FormItem label="保障期限：" class="w600">
			{{info.effectiveDays||''}}天
		</FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:Object,
	},
}
</script>
<style scoped>
	span.price{
		color:red;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/OrderBasicInfoForCommon.vue